<section
  *ngIf="containerMode === ContainerModes.Edit && showBookmarkingExtensionAlert"
  class="alert alert-warning alert--flex u-hide-with-extension"
  role="alert"
>
  <span i18n="@@listDetails-bookmarkExtensionAlert">
    To easily add resources to your lists, install the Bookmarking extension.
  </span>
  <section>
    <button
      class="btn btn-alert btn-default btn-responsive"
      (click)="dismissBookmarkingExtensionAlert()"
      i18n="@@listDetails-bookmarkExtensionAlert-dismiss"
    >
      Dismiss
    </button>
    <button
      class="btn btn-alert--primary btn-responsive"
      (click)="installBookmarkingExtension()"
      i18n="@@listDetails-bookmarkExtensionAlert-install"
    >
      Install Bookmarking Extension
    </button>
  </section>
</section>
<!-- List Header -->
<header class="o-view-header page-header g-0">
  <div class="c-view-title">
    <h1
      *ngIf="!editableList.title"
      id="c-view-title__title"
      class="alpha"
      i18n="@@listDetails-listTitle"
    >
      List title
    </h1>
    <h1 *ngIf="editableList.title" id="c-view-title__title" class="alpha">
      {{ editableList.title }}
    </h1>
    <rl-list-status-panel
      *ngIf="isEditMode"
      [list]="list"
      [editableList]="editableList"
      [permissions]="permissions"
      [listPublishingStatus]="listPublishingStatus"
      [queueSize]="queueSize"
    ></rl-list-status-panel>
  </div>

  <div
    *ngIf="
      containerMode === ContainerModes.View ||
      containerMode === ContainerModes.ViewAsStudent
    "
    class="c-view-actions"
  >
    <div class="c-view-actions__wrapper">
      <rl-edit-menu
        *ngIf="
          canViewEditMenu && containerMode !== ContainerModes.ViewAsStudent
        "
        [list]="list"
        [editableList]="editableList"
        [isEdit]="false"
        [currentUserPermissions]="permissions"
        (showArchiveListModal)="showArchiveListModal.emit($event)"
        (showDeleteListModal)="showDeleteListModal.emit($event)"
        (showEditListDetailsModal)="showEditListDetailsModal.emit($event)"
        (showAssignListOwnersModal)="showAssignListOwnersModal.emit($event)"
        (showRequestReviewModal)="showRequestReviewModal.emit($event)"
        (showReviewHistoryModal)="showReviewHistoryModal.emit($event)"
        (showStudentNumbersAndHierarchyModal)="
          showStudentNumbersAndHierarchyModal.emit($event)
        "
      >
      </rl-edit-menu>

      <div dropdown keyboard-nav="true" class="dropdown">
        <button
          dropdownToggle
          class="btn btn-default btn-responsive btn-lg dropdown-toggle qa-view-dropdown"
          data-bs-toggle="dropdown"
          type="button"
        >
          <ng-container
            *ngIf="exportUrls"
            i18n="@@listDetails-viewMenu-btn-viewAndExport"
            >View & Export</ng-container
          >
          <ng-container
            *ngIf="!exportUrls"
            i18n="@@listDetails-viewMenu-btn-view"
            >View</ng-container
          >
        </button>
        <ul *dropdownMenu class="dropdown-menu">
          <li
            *ngIf="exportUrls"
            class="dropdown-header"
            i18n="@@listDetails-viewMenu-heading-view"
          >
            View
          </li>
          <li
            *ngIf="
              v2DashboardEnabled &&
              (isListAdmin || isListOwner) &&
              containerMode !== ContainerModes.ViewAsStudent
            "
            class="qa-analytics qa-view-menu--view"
          >
            <a
              [href]="dashboardUrl"
              target="_top"
              class="dropdown-item"
              i18n="@@listDetails-viewMenu-btn-analytics"
              >Analytics</a
            >
          </li>
          <li class="qa-view-menu--view">
            <a
              [href]="recentChangesUrl"
              target="_top"
              class="dropdown-item"
              i18n="@@listDetails-viewMenu-btn-recentChanges"
              >Recent changes</a
            >
          </li>
          <ng-container *ngIf="exportUrls">
            <li class="dropdown-divider" role="presentation"></li>
            <li
              class="dropdown-header"
              i18n="@@listDetails-viewMenu-heading-export"
            >
              Export
            </li>
            <li class="qa-view-menu--export">
              <a
                [href]="exportUrls.ris"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadRis"
                >RIS</a
              >
            </li>
            <li class="qa-view-menu--export">
              <a
                [href]="exportUrls.csv"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadCsv"
                >CSV</a
              >
            </li>
            <li class="qa-view-menu--export">
              <a
                [href]="exportUrls.pdf"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadPdf"
                >PDF - List</a
              >
            </li>
            <li
              *ngIf="exportUrls.bibliography ? true : false"
              class="qa-view-menu--export"
            >
              <a
                [href]="exportUrls.bibliography"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadBibliography"
                >PDF - Bibliography</a
              >
            </li>
            <li class="qa-view-menu--export">
              <a
                [href]="exportUrls.docx"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadDocx"
                >Word - List</a
              >
            </li>
          </ng-container>
        </ul>
      </div>

      <button
        *ngIf="list.published_status !== 'archived'"
        (click)="addToMyLists.emit(list.id)"
        [disabled]="
          !isInMyLists ||
          isInMyLists.data ||
          isInMyLists.isLoading ||
          isInMyLists.loadingError
        "
        class="btn btn-default btn-lg btn-responsive qa-add-to-my-lists"
        type="button"
      >
        <ng-container
          *ngIf="
            !isInMyLists || isInMyLists?.data !== true || isInMyLists?.isLoading
          "
        >
          <span class="sr-only" i18n="@@listDetails-btn-addToMyLists"
            >Add to My Lists</span
          >
          <span aria-hidden="true" role="presentation">
            <i class="far fa-plus qa-add-to-my-lists-icon"></i>
            <ng-container i18n="@@listDetails-btn-myLists"
              >My Lists</ng-container
            >
          </span>
        </ng-container>
        <ng-container *ngIf="isInMyLists?.data === true">
          <span class="sr-only" i18n="@@listDetails-btn-inMyLists"
            >In My Lists</span
          >
          <span aria-hidden="true" role="presentation">
            <i class="far fa-check qa-in-my-lists-icon"></i>
            <ng-container i18n="@@listDetails-btn-myLists"
              >My Lists</ng-container
            >
          </span>
        </ng-container>
      </button>
    </div>
  </div>

  <div *ngIf="containerMode === ContainerModes.Edit">
    <div class="c-list-details__unpublished-changes--actions alert--flex">
      <button
        *ngIf="showRequestReviewButton"
        (click)="onRequestReview()"
        type="button"
        class="btn btn-lg btn-primary qa-request-review"
      >
        <ng-container i18n="@@listDetails-btn-requestReview"
          >Request review</ng-container
        >
      </button>

      <button
        *ngIf="showReviewAndPublishButton"
        (click)="onReviewAndPublish()"
        type="button"
        class="btn btn-lg btn-default qa-review-and-publish"
      >
        <ng-container i18n="@@listDetails-btn-reviewAndPublish"
          >Review & Publish</ng-container
        >
      </button>

      <button
        *ngIf="showPublishButton"
        (click)="onPublishList()"
        type="button"
        class="btn btn-lg btn-primary qa-publish"
      >
        <ng-container i18n="@@listDetails-btn-publish">Publish</ng-container>
      </button>
    </div>
  </div>
</header>

<div class="c-list-meta-and-view-actions">
  <!-- List Info -->
  <ul class="c-list-meta list-unstyled">
    <li
      *ngIf="isPrivate"
      class="c-list-meta__item label label-danger qa-privacy-label"
      i18n="@@listDetails-label-private"
    >
      private
    </li>

    <li
      *ngIf="editableList.period?.description"
      class="c-list-meta__item qa-timeperiod-label label {{
        timePeriodLabelClass
      }}"
    >
      {{ editableList.period.description }}
    </li>

    <li
      *ngIf="
        containerMode !== ContainerModes.Edit &&
        list.published_status &&
        list.published_status !== 'published'
      "
      class="c-list-meta__item label label-warning qa-published-status"
    >
      <span class="sr-only" i18n="@@listDetails-label-listPublishStatus"
        >Status</span
      >
      <span>{{ list.published_status }}</span>
    </li>

    <li
      *ngIf="editableList?.owners?.length"
      class="c-list-meta__item qa-list-owner"
    >
      <span i18n="@@listDetails-label-listCreatedBy">By</span>&nbsp;{{
        getListOwnersLabel(editableList.owners)
      }}
    </li>

    <li
      *ngIf="list.last_updated || list.date_created"
      class="c-list-meta__item"
    >
      <i class="fas fa-clock fa-fw" aria-hidden="true"></i>
      <span
        *ngIf="list.date_created"
        class="c-list-meta__item--date qa-date-created"
      >
        <span i18n="@@listDetails-label-listCreated">Created</span>&nbsp;<time
          [attr.datetime]="list.date_created"
          >{{ list.date_created | amLocale : locale | amTimeAgo }}</time
        >
      </span>

      <span
        *ngIf="list.last_updated"
        class="c-list-meta__item--date qa-last-updated"
      >
        <span i18n="@@listDetails-label-listUpdated">Updated</span>&nbsp;<time
          [attr.datetime]="list.last_updated"
          >{{ list.last_updated | amLocale : locale | amTimeAgo }}</time
        >
      </span>
    </li>

    <li
      *ngIf="nodesWithIds?.length === 1"
      class="c-list-meta__item qa-node-link-single"
    >
      <i class="fas fa-link fa-fw" aria-hidden="true"></i>
      <span i18n="@@listDetails-label-listLinkedTo">Linked to</span>
      <a
        [href]="getAbsoluteUrlToTARL(nodesWithIds[0])"
        [attr.title]="nodesWithIds[0].title"
        target="_top"
      >
        {{ nodesWithIds[0].code }}
      </a>
    </li>

    <li
      *ngIf="nodesWithIds?.length > 1"
      dropdown
      class="c-list-meta__item dropdown btn-group--linked-nodes qa-node-link-multiple"
      keyboard-nav="true"
    >
      <button
        dropdownToggle
        class="btn btn-link dropdown-toggle"
        data-bs-toggle="dropdown"
        type="button"
      >
        <i class="fas fa-link fa-fw" aria-hidden="true"></i>
        <span i18n="@@listDetails-btn-listLinkedTo">Linked to</span>
      </button>

      <ul *dropdownMenu class="dropdown-menu">
        <li *ngFor="let node of nodesWithIds">
          <a
            [href]="getAbsoluteUrlToTARL(node)"
            [attr.title]="node.title"
            target="_top"
            class="dropdown-item"
          >
            {{ node.code }}</a
          >
        </li>
      </ul>
    </li>

    <li
      *ngIf="canViewStudentNumbers && editableList?.totalStudentNumbers"
      class="c-list-meta__item qa-student-numbers"
    >
      <i class="fas fa-user fa-fw" aria-hidden="true"></i>
      {{ editableList.totalStudentNumbers }}
      <ng-container i18n="@@listDetails-label-numberOfStudents"
        >{editableList.totalStudentNumbers, plural, one {student} other
        {students}}</ng-container
      >
    </li>
  </ul>

  <div *ngIf="containerMode === ContainerModes.Edit" class="c-view-actions">
    <div class="c-view-actions__wrapper">
      <rl-edit-menu
        *ngIf="canViewEditMenu"
        [list]="list"
        [editableList]="editableList"
        [isEdit]="isEditMode"
        [currentUserPermissions]="permissions"
        (showArchiveListModal)="showArchiveListModal.emit($event)"
        (showDeleteListModal)="showDeleteListModal.emit($event)"
        (showEditListDetailsModal)="showEditListDetailsModal.emit($event)"
        (showAssignListOwnersModal)="showAssignListOwnersModal.emit($event)"
        (showRequestReviewModal)="showRequestReviewModal.emit($event)"
        (showReviewHistoryModal)="showReviewHistoryModal.emit($event)"
        (showStudentNumbersAndHierarchyModal)="
          showStudentNumbersAndHierarchyModal.emit($event)
        "
      >
      </rl-edit-menu>

      <div dropdown keyboard-nav="true" class="dropdown">
        <button
          dropdownToggle
          class="btn btn-default btn-responsive dropdown-toggle qa-view-dropdown"
          data-bs-toggle="dropdown"
          type="button"
        >
          <ng-container
            *ngIf="exportUrls"
            i18n="@@listDetails-viewMenu-btn-viewAndExport"
            >View & Export</ng-container
          >
          <ng-container
            *ngIf="!exportUrls"
            i18n="@@listDetails-viewMenu-btn-view"
            >View</ng-container
          >
        </button>
        <ul *dropdownMenu class="dropdown-menu">
          <li
            *ngIf="exportUrls"
            class="dropdown-header"
            i18n="@@listDetails-viewMenu-heading-view"
          >
            View
          </li>
          <li
            *ngIf="
              v2DashboardEnabled &&
              (isListAdmin || isListOwner) &&
              containerMode !== ContainerModes.ViewAsStudent
            "
            class="qa-analytics qa-view-menu--view"
          >
            <a
              [href]="dashboardUrl"
              target="_top"
              class="dropdown-item"
              i18n="@@listDetails-viewMenu-btn-analytics"
              >Analytics</a
            >
          </li>
          <li class="qa-view-menu--view">
            <a
              [href]="recentChangesUrl"
              target="_top"
              class="dropdown-item"
              i18n="@@listDetails-viewMenu-btn-recentChanges"
              >Recent changes</a
            >
          </li>
          <li
            *ngIf="
              containerMode === ContainerModes.Edit &&
              editableList.hasEverBeenPublished
            "
            class="qa-view-as-student"
          >
            <a
              routerLink="../view_as_student"
              [skipLocationChange]="true"
              class="dropdown-item"
              i18n="@@listDetails-viewMenu-btn-viewAsStudent"
            >
              As student
            </a>
          </li>
          <ng-container *ngIf="exportUrls">
            <li class="dropdown-divider" role="presentation"></li>
            <li
              class="dropdown-header"
              i18n="@@listDetails-viewMenu-heading-export"
            >
              Export
            </li>
            <li class="qa-view-menu--export">
              <a
                [href]="exportUrls.ris"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadRis"
                >RIS</a
              >
            </li>
            <li class="qa-view-menu--export">
              <a
                [href]="exportUrls.csv"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadCsv"
                >CSV</a
              >
            </li>
            <li class="qa-view-menu--export">
              <a
                [href]="exportUrls.pdf"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadPdf"
                >PDF - List</a
              >
            </li>
            <li
              *ngIf="exportUrls.bibliography ? true : false"
              class="qa-view-menu--export"
            >
              <a
                [href]="exportUrls.bibliography"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadBibliography"
                >PDF - Bibliography</a
              >
            </li>
            <li class="qa-view-menu--export">
              <a
                [href]="exportUrls.docx"
                download
                class="dropdown-item"
                i18n="@@listDetails-exportMenu-btn-downloadDocx"
                >Word - List</a
              >
            </li>
          </ng-container>
        </ul>
      </div>

      <button
        *ngIf="list.published_status !== 'archived'"
        (click)="addToMyLists.emit(list.id)"
        [disabled]="
          !isInMyLists ||
          isInMyLists.data ||
          isInMyLists.isLoading ||
          isInMyLists.loadingError
        "
        class="btn btn-default btn-responsive qa-add-to-my-lists"
        type="button"
      >
        <ng-container
          *ngIf="
            !isInMyLists || isInMyLists?.data !== true || isInMyLists?.isLoading
          "
        >
          <span class="sr-only" i18n="@@listDetails-btn-addToMyLists"
            >Add to My Lists</span
          >
          <span aria-hidden="true" role="presentation">
            <i class="far fa-plus qa-add-to-my-lists-icon"></i>
            <ng-container i18n="@@listDetails-btn-myLists"
              >My Lists</ng-container
            >
          </span>
        </ng-container>
        <ng-container *ngIf="isInMyLists?.data === true">
          <span class="sr-only" i18n="@@listDetails-btn-inMyLists"
            >In My Lists</span
          >
          <span aria-hidden="true" role="presentation">
            <i class="far fa-check qa-in-my-lists-icon"></i>
            <ng-container i18n="@@listDetails-btn-myLists"
              >My Lists</ng-container
            >
          </span>
        </ng-container>
      </button>
    </div>
  </div>
</div>

<dl class="c-list-details__description-list">
  <div *ngIf="editableList.description" class="o-list-description mb-1">
    <dt i18n="@@listDetails-descriptionList-description" class="text-nowrap">
      Description:
    </dt>
    <dd>{{ editableList.description }}</dd>
  </div>
  <div
    *ngIf="canViewInternalNote && editableList.internalNote"
    class="o-list-internal-note"
  >
    <dt i18n="@@listDetails-descriptionList-internalNote" class="text-nowrap">
      Internal note:
    </dt>
    <dd>{{ editableList.internalNote }}</dd>
  </div>
</dl>
